/* @flow */
import * as React from 'react';

import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import DialogContent from 'components/DialogContent.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import RecipientParser from 'lib/RecipientParser';
import UserActions from 'user/UserActions';

type Props = {
  onDone: Function,
  onError: Function,
};

export default class JoinInfoPageParentEmail extends React.Component<Props, $FlowFixMeState> {
  state = {
    canSubmit: false,
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  submit = (attrs: Object) => {
    const token = RecipientParser.newToken(attrs.address);

    UserActions.addParent(attrs.full_name, token.address).then(
      this.props.onDone,
      this.props.onError
    );
  };

  render() {
    return (
      <DialogContent
        size="small"
        full
        className="JoinInfoPageParentEmail"
        title="Enter your parent’s name and contact information"
        subtext="They’ll be added to Remind and get the same messages you do.">
        <BoxBody divided>
          <Form
            onValid={this.enableButton}
            onInvalid={this.disableButton}
            onValidSubmit={this.submit}>
            <FormInput
              label="Parent’s full name"
              required
              name="full_name"
              showErrorOnPristine={false}
              placeholder="First and last name"
              validations={{
                maxLength: 255,
              }}
              validationErrors={{
                maxLength: 'Name should be shorter than 255 characters.',
              }}
            />
            <FormInput
              label="Contact information"
              type="text"
              name="address"
              placeholder="Phone number or email address"
              validations="isEmailOrPhone"
              validationError="Invalid phone or email"
              showErrorAfterBlur
            />
            <Button disabled={!this.state.canSubmit} type="submit">
              Done
            </Button>
          </Form>
        </BoxBody>
      </DialogContent>
    );
  }
}
